import { hasAtLeast } from 'remeda'
import { ImageCard } from '@velasca/ui/image-card'
import { MaxWidthContainer } from '@velasca/ui/max-width-container'
import { TitleComposition } from '@velasca/ui/title-composition'
import { Background, Cards, Layout } from './CategoriesBlock.styles'
import type { CategoriesBlockProps } from './CategoriesBlock.types'

export const CategoriesBlock = ({
  title,
  subtitle,
  imageCards,
}: CategoriesBlockProps): JSX.Element | null => {
  if (!title || !subtitle || !imageCards || !hasAtLeast(imageCards, 1)) {
    return null
  }

  return (
    <Background>
      <MaxWidthContainer>
        <Layout>
          <TitleComposition title={title} upperTitle={subtitle} />
          {
            <Cards>
              {imageCards?.map((imageCard, i) => (
                <ImageCard key={i} {...imageCard} />
              ))}
            </Cards>
          }
        </Layout>
      </MaxWidthContainer>
    </Background>
  )
}
